/**
 * @section 4.1.9.2
 */
/* eslint-disable no-template-curly-in-string, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import { Avatar } from "@material-ui/core";
import axios from "axios";
import { t } from "i18next";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useParents from "./../../apihooks/useParents";
import { useAppContext } from "./../../context/AppCtxProvider";
import { wfStatesMap as kpiWfStatesMap } from "./../../pages/kpisapproval/KpisApproval";
import ProjectHeading from "./../../ui/components/ProjectHeading";
import TextSelectProjectFromList from "./../../ui/components/TextSelectProjectFromList";
import PageTabs from "./../../ui/tabs/Tabs";
import { makeThemedStyles } from "./../../viewcomponents/utils";
import { wfStatesMap } from "./WorkflowProjectList";
import { IWokflowDescription } from "./workflowTypes";
const pageTabs = [
  { title: "WORKFLOW", viewName: "workflowsteps" },
  { title: "LOGS", viewName: "workflowlogs" },
];
const acceptMilestoneTabs = [
  { title: "WORKFLOW", viewName: "acceptmsworkflowsteps" },
  { title: "LOGS", viewName: "acceptmsworkflowlogs" },
];
const kpiWorkflowTabs = [
  { title: "WORKFLOW", viewName: "kpiworkflowsteps" },
  { title: "LOGS", viewName: "kpiworkflowlogs" },
];
const steps: Array<IWokflowDescription> = [
  {
    stepName: "Final approver",
    stepNumber: 3,
    stepState: "finalapproval",
  },
  {
    stepName: "Initial approver",
    stepNumber: 2,
    stepState: "approval",
  },
  {
    stepName: "Data entry",
    stepNumber: 1,
    stepState: "dataentry,update",
  },
];
const useStyles = makeThemedStyles("MilestoneInput.Heading", (theme) => ({
  container: {
    width: "100%",
  },
}));
const stepKey = ({ stepName, stepNumber }: IWokflowDescription) =>
  `${stepName}-${stepNumber}`;
const WorkFlowStep = (props: IWokflowDescription) => {
  let { stepName, stepNumber, currentStep, actor } = props;
  const isCurrent = currentStep === stepNumber;
  if (currentStep === 4) currentStep = 3;
  let top = 15;
  if (currentStep === 3) top = -90;
  if (currentStep === 2) {
    if (stepNumber === 1) top = -90;
    if (stepNumber === 3) top = 0;
  }
  return (
    <div
      className={`WorkflowStep ${isCurrent ? "Final" : ""} `}
      key={stepKey(props)}
    >
      <div className="WorkflowRole">{t(stepName)}</div>
      <div className="CircleContainer">
        <div className="CircleContainerLineWrapper">
          <div className="CircleContainerLine" style={{ top: `${top}px` }} />
        </div>

        {isCurrent ? (
          <div className="WorkflowActionCircleEnd">
            <div className="WorkflowActionCircleInner" />
          </div>
        ) : (
          <div
            className={
              isCurrent ? "WorkflowActionCircleEnd" : `WorkflowActionCircle`
            }
          >
            {stepNumber}
          </div>
        )}
      </div>
      <div className="WorkflowOwner">
        <div className="avatar">
          <Avatar alt={actor?.username} />
        </div>
        <div className="details">
          <div className="name">{t(actor?.username || "")}</div>
          <div className="role">{t(actor?.role || "")}</div>
        </div>
      </div>
    </div>
  );
};
type IWorkflowProjectList = {
  query?: string;
  attributes?: string;
  title?: string;
  variant?: string;
};
const WorkflowSteps = (props: {
  componentData: IWorkflowProjectList;
  options?: any;
  isKpi?: boolean;
  selectedRow?: any;
}) => {
  const ctx = useAppContext();
  const classes = useStyles();
  const data = useParents(ctx.elementId || "");
  const [currentStep, setCurrentStep] = React.useState<number | undefined>();
  const [actors, setActors] = React.useState<
    Array<{
      username: string;
      role: string;
    }>
  >([]);
  const period =
    new URLSearchParams(useLocation().search).get("wfperiod") || "null";
  const [wfInstanceId, setWfInstanceId] = React.useState<string | undefined>(
    ""
  );
  const wf =
    props.selectedRow && props.selectedRow[0]
      ? props.selectedRow[0]?.workflow
      : null;
  useEffect(() => {
    (async () => {
      if (wfInstanceId) {
        const data = await axios.get(`workflow/roles/${wfInstanceId}`);
        setActors(data.data.data);
      }
    })();
  }, [wfInstanceId]);
  useEffect(() => {
    const setStep = async () => {
      setWfInstanceId((prev) => {
        return wf ? wf.wfInstanceId : prev;
      });
      if (wf) {
        const { currentState } = wf;
        const states =
          (ctx.page || "").indexOf("kpi") >= 0 ? kpiWfStatesMap : wfStatesMap;
        setCurrentStep(
          states.find((el) => el.uiname === currentState)?.stepnumber
        );
      }
    };
    setStep();
  }, [props.selectedRow]);
  if (!data || !ctx.elementId || (data && data.length === 0)) {
    return <TextSelectProjectFromList isKpi={props.isKpi} />;
  }
  const [element] = data.reverse();
  const tabOptions = () => {
    if ((ctx.page || "").indexOf("accept") >= 0) {
      return acceptMilestoneTabs;
    }
    if ((ctx.page || "").indexOf("kpi") >= 0) {
      return kpiWorkflowTabs;
    }
    return pageTabs;
  };
  return (
    <div className={classes.container}>
      <ProjectHeading
        title={element.name}
        attributes={{
          jsattr: element.JS_ATTR,
          typename: element.typename,
        }}
      >
        <PageTabs selected={ctx.page} options={tabOptions()} />
      </ProjectHeading>
      <div className="WorkflowStepsContainer">
        <div className="WorkflowSteps">
          {currentStep === undefined ? (
            <> </>
          ) : (
            steps.map((step) => (
              <WorkFlowStep
                key={stepKey(step)}
                {...step}
                currentStep={currentStep}
                actor={actors.find((el: any) =>
                  step.stepState.split(",").includes(el.state)
                )}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};
export default WorkflowSteps;
